import { defineComponent as _defineComponent } from 'vue'
import { inject, onMounted } from 'vue'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import LfSimpleProgressBarComponent from '@/components/ProgressBar/LfSimpleProgressBarComponent.vue'
import { useI18n } from 'vue-i18n-composable'
import {
  useImportExpedientsProcessStore
} from '@/views/Expedients/components/ImportExpedientsDialog/stores/useImportExpedientsProcessStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportExpedientsLoadingComponent',
  setup(__props) {

const { t } = useI18n()
const nextStep = inject('nextStep') as () => void
const importExpedientsProcessStore = useImportExpedientsProcessStore()

const TEXT = {
  title: t('components.expedient_import_dialog.title').toString(),
  caption: t('components.expedient_import_dialog.loading.caption').toString(),
  note: t('components.expedient_import_dialog.loading.note').toString()
}

onMounted(async () => {
  try {
    await importExpedientsProcessStore.executeExpedientImport()
  } catch (error){
    console.log('Error', {error})
  } finally {
    nextStep()
  }
})


return { __sfc: true,t, nextStep, importExpedientsProcessStore, TEXT, LfBlueTitleComponent, LfSimpleProgressBarComponent }
}

})